import { Component, OnInit, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-store-url',
  templateUrl: './store-url.component.html',
  styleUrls: ['./store-url.component.scss'],
})
export class StoreUrlComponent implements OnInit {
  @Input() id: any;
  url: string = environment.shopUrl;
  storeurl: any;
  constructor(public dialogRef: NbDialogRef<StoreUrlComponent>) {}
  ngOnInit() {
    this.storeUrl();
  }
  storeUrl() {
    this.storeurl = this.url + this.id;
    // console.log( this.storeurl)
  }
  onBack() {
    this.dialogRef.close();
  }
}
